import superagent from 'superagent';
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';

export const fetchShortNumber = createAsyncThunk(
	'shortNumber/shortNumberLoading',
	(options, {getState}) => superagent
			.post(`${getState().status.shortNumberUrl}/shortNumber/getOrCreate`)
			.query({prefixLevels: options.prefixLevels})
			.send({data: options.data})
			.set('Accept', 'application/json')
			.set('Content-Type', 'application/json')
			.then((response) => response.body)
			.catch((error) => error)
);
export const loadConfigByShortNumber = createAsyncThunk(
	'shortNumber/loadConfigByShortNumberLoading',
	(options, {getState}) =>
		superagent
			.get(`${getState().status.shortNumberUrl}/shortNumber/getConfigurationData?shortNumber=${options.shortNumber}`)
			.set('Accept', 'application/json')
			.then((response) => response.body)
			.catch((error) => error)
);

const shortNumberInitialState = {
	status: 'idle',
	data: {
		firstPrefixLevel: null,
		loadedConfig: null,
	},
	error: {},
};
export const shortNumberSlice = createSlice({
	name: 'shortNumber',
	initialState: shortNumberInitialState,
	reducers: {
		clearShortNumberConfig: (state, action) => {
			state = shortNumberInitialState;
		}
	},
	extraReducers: (builder) => {
		builder.addCase(fetchShortNumber.fulfilled, (state, action) => {
			const firstPrefixLevel = action.meta.arg.prefixLevels[0];
			state.data[firstPrefixLevel] = action.payload;
			state.status = 'idle';
			state.error = {};
		});
		builder.addCase(fetchShortNumber.pending, (state, action) => {
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(fetchShortNumber.rejected, (state, action) => {
			state.data = {};
			state.status = 'idle';
			state.error = action.payload;
		});
		builder.addCase(loadConfigByShortNumber.fulfilled, (state, action) => {
			state.data.loadedConfig = JSON.parse(action.payload.data);
			state.data.prefixLevels = action.payload.prefixLevels;
			state.status = 'idle';
			state.error = {};
		});
		builder.addCase(loadConfigByShortNumber.pending, (state, action) => {
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(loadConfigByShortNumber.rejected, (state, action) => {
			state.data.loadedConfig = null;
			state.status = 'idle';
			state.error = action.payload;
		});
	}
});


export const {
	clearShortNumberConfig
} = shortNumberSlice.actions;


export default shortNumberSlice.reducer;
